
@switch (bubbleType) {
  @case ('image') {
    <app-image [messageSource]="emulatorMessage | isUserMessage" [content]="content"></app-image>
  }
  @case ('file') {
    <app-file [messageSource]="emulatorMessage | isUserMessage" [content]="content"></app-file>
  }
  @case ('voicenote') {
    <app-voice-note [messageSource]="emulatorMessage | isUserMessage" [content]="content"></app-voice-note>
  }
  @case ('video') {
    <app-video [messageSource]="emulatorMessage | isUserMessage" [content]="content"></app-video>
  }
  @case ('location') {
    <app-location [messageSource]="emulatorMessage | isUserMessage" [content]="content"></app-location>
  }
  @case ('contact') {
    <app-contact-bubble [messageSource]="emulatorMessage | isUserMessage" [content]="content"></app-contact-bubble>
  }
  @case ('interactive') {
    <app-interactive-message-chat-bubble  [content]="content"></app-interactive-message-chat-bubble>
  }
  @case ('button') {
    <app-buttons-chat-bubble [content]="content" (sendOption)='sendMessageEmitter($event)'></app-buttons-chat-bubble>
  }
  @case ('list') {
    <app-options-chat-bubble [content]="emulatorMessage | getListContent: 'OneApiListPickerEvent'" (sendOption)='sendMessageEmitter($event)'></app-options-chat-bubble>
  }
  @case ('requestlocation') {
    <app-request-location [content]="content" (sendLocation)="sendLocationEmitter($event)"></app-request-location>
  }
  @case ('actionUrl') {
    <app-action-url-chat-bubble [content]="content"></app-action-url-chat-bubble>
  }
  @default {
    <div class="message-container">
      <div [ngClass]="{ 'preview-chat-message-out': emulatorMessage | isUserMessage, 'preview-chat-message-in': !(emulatorMessage | isUserMessage) }">
        @if (chatBubbleService.isCheckURl || chatBubbleService.isFirstURl) {
          <div>
            <ng-container *ngTemplateOutlet="msgTemplate"></ng-container>
          </div>
        } @else {
          <div [innerHTML]="checkdefaultURL()"></div>
        }
        @if (emulatorMessage | isUserMessage) {
          <app-read-receipt [messageStatus]="content['messageStatus']"></app-read-receipt>
        }
      </div>
      <div class="counter-container">
        @if (shouldShowCharCount) {
          <div
            class="preview-chat-message-out-counter">
            @if (urlPreviewData) {
              <span>{{ charCount }} {{ charCount === 1 ? 'Character' : 'Characters' }}</span>
            }
          </div>
        } @else {
          @if (!(emulatorMessage | isUserMessage)) {
            <div class="preview-chat-message-out-divider"></div>
          }
        }
      </div>
    </div>
  }
}


<ng-template #msgTemplate>
  @if (currentChannel !== 7 && urlPreviewData && urlPreviewData['rootUrl'] !== null && urlPreviewData['mainUrl'] !== null) {
    <ng-container *ngTemplateOutlet="urlPreviewTemplate"></ng-container>
  } @else {
    @if (currentChannel !== 7) {
      <div>
        <label>{{urlPreviewData.remainder}}</label>
      </div>
    } @else {
      <!--  USSD ONLY   -->
      <label>{{emulatorMessage.message}}</label>
    }
  }
</ng-template>





<ng-template #urlPreviewTemplate>
  <app-url-preview [emulatorMessage]="emulatorMessage">
  </app-url-preview>
</ng-template>